/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import templates from "./collection-templates";

export function getCollectionTemplate(designTemplate) {
  return templates[designTemplate] || templates.defaultTemplate;
}

const getSpecificData = (data) => {
  return Object.entries(templates).reduce((acc, [key, value]) => {
    if (data === "storyLimit") {
      const getValidKeyValue = value.storyLimit ? { [key]: value.storyLimit } : {};
      return { ...acc, ...getValidKeyValue };
    } else if (data === "nestedCollectionLimit") {
      const getValidKeyValue = value.nestedCollectionLimit ? { [key]: value.nestedCollectionLimit } : {};
      return { ...acc, ...getValidKeyValue };
    }
    return {};
  }, {});
};

export function getStoryLimits() {
  return getSpecificData("storyLimit");
}

export function getNestedCollectionLimit() {
  return getSpecificData("nestedCollectionLimit");
}
